/**
 * gamesis Notification Model
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Subscription { 
    readonly id: string;
    readonly created: string;
    label?: string;
}

